import { Injectable } from '@angular/core';
import { CanMatch, Route, UrlSegment } from '@angular/router';

@Injectable({ providedIn: 'root' })
export class PublicStatusDomainGuard implements CanMatch {
  canMatch(route: Route, segments: UrlSegment[]): boolean {
    if (typeof window === 'undefined' || !window.location?.hostname) {
      return false;
    }

    const host = window.location.hostname.toLowerCase();

    const isAppHost =
      host === 'localhost' ||
      host.endsWith('.localhost') ||
      host.startsWith('app.');

    if (isAppHost) {
      return false;
    }

    // For custom domains, always keep user on public status page app flow.
    return true;
  }
}
